import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionBuilderPage } from './pages/transaction-builder/transaction-builder.page';
import { TransactionBuilderRoutingModule } from 'src/app/transaction-builder/transaction-builder-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatSelectModule,
  MatToolbarModule,
  MatSidenavModule,
  MatDividerModule,
  MatTableModule,
  MatRadioModule,
  MatDialogModule,
  MatExpansionModule,
  MatButtonToggleModule,
  MatMenuModule,
  MatTooltipModule,
  MatSlideToggleModule,
  MatTabsModule,
} from '@angular/material';
import { ClientFormCardComponent } from './components/client-form-card/client-form-card.component';
import { DocumentCardComponent } from './components/document-card/document-card.component';
import { HttpClientModule } from '@angular/common/http';
import { NgxMatEsign360Module } from 'ngx-mat-esign360';
import { DocumentEditorPage } from './pages/document-editor/document-editor.page';
import { SignFieldViewerComponent } from './components/sign-field-viewer/sign-field-viewer.component';
import { ClientFormSectionComponent } from './components/client-form-section/client-form-section.component';
import { DocumentFormSectionComponent } from './components/document-form-section/document-form-section.component';
import { SharedModule } from '@app/shared/shared.module';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxMatIntlTelInputModule } from 'ngx-mat-intl-tel-input';
import { IsTransactionDataCompletePipe } from './pipes/is-transaction-data-complete.pipe';
import { FilterSignFieldsOnPagePipe } from './pipes/filter-sign-fields-on-page.pipe';
import { SignFieldCanvasComponent } from './components/sign-field-canvas/sign-field-canvas.component';
import { FilterDocumentSignersPipe } from './pipes/filter-document-signers.pipe';
import { BoundingBoxPipe } from './pipes/bounding-box.pipe';
import { FilterCompleteClientsPipe } from './pipes/filter-complete-clients.pipe';
import { DocEditorSidePanelComponent } from './components/doc-editor-side-panel/doc-editor-side-panel.component';
import { FilterSignFieldsBySignerPipe } from './pipes/filter-sign-fields-by-signer.pipe';
import { SignatureTypeSelectComponent } from './components/signature-type-select/signature-type-select.component';
import { SignFieldListItemComponent } from './components/sign-field-list-item/sign-field-list-item.component';
import { EditableSignFieldComponent } from './components/editable-sign-field/editable-sign-field.component';
import { SigningRequestChannelSelectComponent } from './components/signing-request-channel-select/signing-request-channel-select.component';
import { CollectiveDocsSignatureTypePipe } from './pipes/collective-docs-signature-type.pipe';
import { IsClientFieldVisiblePipe } from './pipes/is-client-field-visible.pipe';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { InvokingUserSectionComponent } from './components/invoking-user-section/invoking-user-section.component';

@NgModule({
  declarations: [
    TransactionBuilderPage,
    ClientFormCardComponent,
    DocumentCardComponent,
    DocumentEditorPage,
    SignFieldViewerComponent,
    ClientFormSectionComponent,
    DocumentFormSectionComponent,
    IsTransactionDataCompletePipe,
    FilterSignFieldsOnPagePipe,
    SignFieldCanvasComponent,
    FilterDocumentSignersPipe,
    BoundingBoxPipe,
    FilterCompleteClientsPipe,
    DocEditorSidePanelComponent,
    FilterSignFieldsBySignerPipe,
    SignatureTypeSelectComponent,
    SignFieldListItemComponent,
    EditableSignFieldComponent,
    SigningRequestChannelSelectComponent,
    CollectiveDocsSignatureTypePipe,
    IsClientFieldVisiblePipe,
    InvokingUserSectionComponent,
  ],
  imports: [
    SharedModule,
    TransactionBuilderRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatToolbarModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSidenavModule,
    NgxMatEsign360Module,
    MatDividerModule,
    MatTableModule,
    MatRadioModule,
    MatDialogModule,
    NgxDropzoneModule,
    MatExpansionModule,
    NgxMatIntlTelInputModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatTabsModule,
    NgJsonEditorModule,
  ],
  providers: [IsTransactionDataCompletePipe],
})
export class TransactionBuilderModule {}
